<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col col-1">
      <h6>{{ displayNameZakelijkPartner }}</h6>
    </div>
    <div class="col-2">
    </div>
    <div class="col-3 bold">
      Huidige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <!--  <ng-container *ngIf="this.showCustomControls">-->
  <form [formGroup]="equityFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Eigen vermogen aan het begin van de periode</p>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px"><b>Mutaties gedurende de periode</b></p>
    </div>
  </div>
  <form [formGroup]="privateIntakesNaturalPersonsFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Privé opnamen</p>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="privateDepositesNaturalPersonsFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Privé stortingen</p>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="equityResultAllocationFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Allocatie van het resultaat</p>
      </div>
      <div class="col-2">
        @if (isEquityResultAllocationTrialBalanceItemsButtonVisible) {
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(3)">Specificatie
          </snelstart-ui-button>
        }
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="oldAgeTaxAllowanceWithdrawalFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Onttrekking oudedagsreserve</p>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="equityMovementOtherFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Overige mutaties</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(1)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="equityMovementFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px"><b>Totaal van mutaties gedurende de periode</b></p>
      </div>
      <div class="col-2"></div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="equityFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px"><b>Eigen vermogen aan het einde van de periode</b></p>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <div class="row">
    <div class="col col-1">
      <h6>{{ displayNameZakelijkPartner }}</h6>
    </div>
  </div>
  <div class="pt-3"></div>
  <form [formGroup]="equityNaturalPersonDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over eigen vermogen zakelijke partner</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.equityNaturalPersonDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(2)">
          {{ this.equityNaturalPersonDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="this.selectedTab === 2">
  <form [formGroup]="priveOpnamenStortingenSpecificatieFg">
    <div class="row">
      <div class="col col-1">
        <h6>{{ displayNameZakelijkPartner }}</h6>
      </div>
      <div class="col-2 bold">
        Huidige periode
      </div>
      <div class="col-3 bold">
        Vorige periode
      </div>
    </div>
    <div class="pt-3"></div>
    <ng-container formArrayName="priveOpnamenStortingen">
      @for (item of priveOpnamenStortingen.controls; track item; let i = $index) {
        <ng-container [formGroupName]="i">
          <div class="row">
            <ng-container formGroupName="privateDepositesIntakesDescriptionTypedMember">
              <label for="privateDepositesIntakesDescriptionTypedMember" class="form-label">
                Unieke omschrijving van de privé opname/storting
              </label>
              <div>
                <snelstart-ui-text-form-control formControlName="value"
                                                id="privateDepositesIntakesDescriptionTypedMember"
                                                class="me-1 custom-input-500"
                                                (change)="this.saveForm()"
                >
                </snelstart-ui-text-form-control>
              </div>
            </ng-container>
            <ng-container formGroupName="privateIntakesNaturalPersons">
              <div class="row">
                <div class="col col-1">
                  <p style="padding: 6px">Privé opname</p>
                </div>
                <div class="col-2">
                </div>
                <div class="col-3">
                  <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                    class="custom-input-150"
                                                    align="right"
                                                    [showAllDecimals]="false"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                <div class="col-4">
                  <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                    class="custom-input-150"
                                                    align="right"
                                                    [showAllDecimals]="false"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
              </div>
            </ng-container>
            <ng-container formGroupName="privateDepositesNaturalPersons">
              <div class="row">
                <div class="col col-1">
                  <p style="padding: 6px">Privé storting</p>
                </div>
                <div class="col-2">
                </div>
                <div class="col-3">
                  <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                                    class="custom-input-150"
                                                    align="right"
                                                    [showAllDecimals]="false"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
                <div class="col-4">
                  <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                                    class="custom-input-150"
                                                    align="right"
                                                    [showAllDecimals]="false"
                                                    (change)="this.saveForm()"
                  >
                  </snelstart-ui-number-form-control>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRijPriveOpnamenStortingen(i)"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
          <hr>
        </ng-container>
      }
    </ng-container>
    <div>
      <snelstart-ui-button id="addO" class="snelstart-ui-button pb-3" type="link" icon="plus"
                           (click)="addRijPriveOpnamenStortingen()">Item toevoegen
      </snelstart-ui-button>
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.equityMovementOtherFg"
                                                       [title]="'overige mutaties'"
                                                       [period2Visible]="false"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance-read-only [(dialogVisible)]="this.dialogVisible"
                                                                 [input]="this.equityResultAllocationFg"
                                                                 [title]="'allocatie van het resultaat'"
                                                                 [period2Visible]="false"
  ></snelstart-venture-fiscaal-feature-spec-trialbalance-read-only>
</div>

<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.equityNaturalPersonDisclosureFg"
                                                               [title]="'Informatieverschaffing over eigen vermogen zakelijke partner'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

